import React, { Dispatch } from 'react';
import { Box, Button } from '@mui/material';
import { classes } from './styles';
import { TableActionDrawerAction } from './types';
import { Clear, SelectAll } from '@mui/icons-material';

// The parentDiv prop is used to center the tooltip in relation to the table and not the
// entire page. You can pass in a ref.current which should be a parent div with 100% width

const TotalSelectedIndicatorWithActions = ({
  totalSelected,
  parentDiv,
  dispatch,
  actionButtonsList,
  actionCall,
  actionButtonId = '',
  onSelectAll,
  clearAllEnabled,
  totalItems,
  canSelectAll
}: {
  totalSelected: number;
  parentDiv: HTMLDivElement | null;
  dispatch?: Dispatch<TableActionDrawerAction>;
  actionButtonsList?: {
    id: string;
    label: string;
    icon: JSX.Element;
    callback?: () => void;
  }[];
  actionCall?: null | (() => void);
  actionButtonId?: string;
  onSelectAll?: () => void;
  clearAllEnabled?: boolean;
  totalItems?: number;
  canSelectAll?: boolean;
}) => {
  return (
    <Box
      id="selected-tooltip"
      sx={{
        ...classes.selectedTooltip,
        left: parentDiv
          ? parentDiv.getBoundingClientRect().left +
            parentDiv.getBoundingClientRect().width / 2 -
            332 // this is half the size of the 'tooltip' div
          : 55, // this value for when the parent div is inside a modal
        ...(totalSelected ? classes.fadeIn : classes.fadeOut)
      }}
    >
      <Box id="selected-tooltip-text" sx={classes.selectAllWithActionsTooltip}>
        {totalSelected} selected
        <Box>
          {actionButtonsList &&
            dispatch &&
            actionButtonsList.map((action) => (
              <Button
                sx={{
                  ...classes.selectAllWithActionsTooltipButton,
                  marginLeft: '5px'
                }}
                startIcon={action.icon}
                onClick={() => {
                  dispatch &&
                    dispatch({
                      type: 'SET_ACTION_MODAL_OPEN',
                      payload: { name: action.id, isOpen: true }
                    });
                  action.callback && action.callback();
                  actionCall && actionCall();
                }}
                key={action.id}
                id={actionButtonId}
              >
                {action.label}
              </Button>
            ))}
          {clearAllEnabled && (
            <Button
              sx={{
                ...classes.selectAllWithActionsTooltipButton,
                marginLeft: '5px'
              }}
              onClick={() => dispatch && dispatch({ type: 'REMOVE_ALL_SELECTED_ITEMS' })}
              startIcon={<Clear />}
            >
              Clear
            </Button>
          )}
          {onSelectAll && canSelectAll && (
            <Button
              sx={{
                ...classes.selectAllWithActionsTooltipButton,
                marginLeft: '5px'
              }}
              onClick={onSelectAll}
              startIcon={<SelectAll />}
            >
              Select all {totalItems} items
            </Button>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default TotalSelectedIndicatorWithActions;
